export default function(data) {
var __t, __p = '';
__p += '<span class="link expand-comments"></span>\n<div class="comment-toggle" style=' +
((__t = ( this.getSlideState() )) == null ? '' : __t) +
'>\n  <div id="comment-form"></div>\n  <ul class="comment-list reset" id="discussion-comments"></ul>\n  <div id="comments-pagination"></div>\n  <span class="link expand-comments"></span>\n</div>';
return __p
}